/*
*   @site           Preloaded: Site
*   @function       Template: Module
*   @author         Last17
*   @copyright      Copyright 2025, Preloaded.com
*   @version        0.01
*
*********************************************************************************************/


//-----------------------------------------------
// Imports
//-----------------------------------------------
import LayoutController from '../_controllers/LayoutController';

//-----------------------------------------------
// Class Definition
//-----------------------------------------------
export default class ModuleTemplate {
  

  //-----------------------------------------------
  // Constructor
  //-----------------------------------------------
  constructor(element, id) {

    //Element
    this.element = element;
    this.id = id;

    //Size
    this.size = {width: this.element.offsetWidth, height: this.element.offsetHeight};
    this.setSize(); 

    //Flag
    this.flags = {
      listen: {
        scroll: false,
        resize: false
      }
    };

    //Init
    this.init();

    //Handle generic shapes etc.
    this.scrollElements = [];
    /*
    let keylines = this.element.querySelectorAll('.keyline');
    if(keylines.length > 0) {
      for(let i = 0; i < keylines.length; i++) {
        this.scrollElements.push({
          type: 'keyline',
          element: keylines[i],
          rotation: keylines[i].getAttribute('data-rotation-start') || 0,
          offsetMax: 0.25 //proportion of height to scroll by
        });
      }

      //Scroll events
      this.subscribeToEvent('scroll');
    }*/

    //Layout
    this.setLayout(LayoutController.layout);
  }


  //-----------------------------------------------
  // Override this
  //-----------------------------------------------
  init() {

  }


  //-----------------------------------------------
  // Set size
  //-----------------------------------------------
  setSize() {
    //Store the size
    this.size = {width: this.element.offsetWidth, height: this.element.offsetHeight};
  }


  //-----------------------------------------------
  // Subscribe to Event
  //-----------------------------------------------
  subscribeToEvent(type) {
    if(!this.flags.listen[type]) {
      //Subscribe
      if(type == 'scroll') {
        LayoutController.listenToScroll({
          scope:this,
          func: this.scrollEvent
        });
      }

      //Flag
      this.flags.listen[type] = true;
    }
  }


  //-----------------------------------------------
  // Resize event (passed down )
  //-----------------------------------------------
  resizeEvent(data) {
    //Change the layout if we need to
    if (data.changed.layout) {
      this.setLayout(data.layout);
    }

    //Custom resize
    this.onResize(data);

    //Set the size
    this.setSize();
  }

  //-----------------------------------------------
  // Scroll event
  //-----------------------------------------------
  scrollEvent(data) {
  }
  

  //-----------------------------------------------
  // Get scroll bounds
  //-----------------------------------------------
  getScrollBounds(heightProportion) {
    //Value
    heightProportion = (heightProportion !== undefined) ? heightProportion : 1;

    //Bounds
    let bounds = {
      min:(this.element.offsetTop > window.innerHeight) ? this.element.offsetTop - window.innerHeight : 0,
      max: 0
    };
    bounds.max = this.element.offsetTop + (this.size.height * heightProportion);

    //Max can't be higher than the maximum scroll of the page
    bounds.max = Math.min(bounds.max, document.documentElement.scrollHeight - window.innerHeight);

    //Return
    return bounds;
  }


  //-----------------------------------------------
  // Custom resize
  //-----------------------------------------------
  onResize(data) {

  }


  //-----------------------------------------------
  // Set layout
  //-----------------------------------------------
  setLayout(layout) {
  }

}